import EditPersonalia from './EditPersonalia'

export default EditPersonalia
